<template>
    <div class="site-area-relevance-selector">
        <selection-option-card
            v-for="option in props.options"
            :key="option"
            class="site-area-relevance-card"
            :selected="isSelected(option)"
            :title="getSiteAreaRelevanceLabel(option)"
            :fa-icon="['fas', getSectionIcon(option)]"
            :icon-text-color="getSectionColour(option)"
            :style="getCardStyle(option)"
            @click="toggleOption(option)"
        />
    </div>
</template>

<script setup lang="ts">
import SelectionOptionCard from '@/components/common/SelectionOptionCard.vue';
import {
    getSiteAreaRelevanceColour,
    getSiteAreaRelevanceIcon,
    getSiteAreaRelevanceLabel,
} from '@/utils/siteAreaRelevanceUtils.ts';

const props = defineProps<{
    options: Array<string>;
    modelValue: Array<string>;
    requireAtLeastOne?: boolean;
}>();

const emit = defineEmits<{
    'update:modelValue': [Array<string>];
}>();

function isSelected (option: string): boolean {
    return props.modelValue.includes(option);
}

function toggleOption (option: string): void {
    if (isSelected(option)) {
        if (props.requireAtLeastOne && props.modelValue.length <= 1) return;
        emit('update:modelValue', props.modelValue.filter(selectedOption => selectedOption !== option));
        return;
    }

    emit('update:modelValue', [...props.modelValue, option]);
}

function getSectionColour (option: string): string {
    return getSiteAreaRelevanceColour(option);
}

function getSectionIcon (option: string): string {
    return getSiteAreaRelevanceIcon(option);
}

function getCardStyle (option: string): Record<string, string> {
    return {
        '--site-area-relevance-colour': getSectionColour(option),
    };
}
</script>

<style scoped lang="scss">
.site-area-relevance-selector {
    display: grid;
    gap: var(--defaultSpacing);
    grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr));
    padding: var(--defaultSpacing) 0;
}

.site-area-relevance-card {
    min-height: 5.4rem;

    :deep(.font-awesome-icon-wrapper) {
        background: transparent;
        padding: 0;
    }
}

:deep(.site-area-relevance-card.selection-option-card) {
    border-color: transparent;
}

:deep(.site-area-relevance-card.selection-option-card.selected) {
    border-color: var(--site-area-relevance-colour);
    box-shadow: 0 0 0 1px var(--site-area-relevance-colour);
}
</style>
